import { render, staticRenderFns } from "./bidListPage.vue?vue&type=template&id=07729ef6&"
import script from "./bidListPage.vue?vue&type=script&lang=ts&"
export * from "./bidListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports